import { TeamMember } from 'lib/services/TeamMemberService';
import styles from './TeamMemberContactLinks.module.scss';

export const TeamMemberContactLinks: React.FC<{ teamMemberData: TeamMember }> = ({
  teamMemberData,
}) => {
  const hasContactLinks =
    teamMemberData.phoneNumber?.value ||
    teamMemberData.email?.value ||
    teamMemberData.linkedin?.url ||
    teamMemberData.twitter?.url ||
    teamMemberData.downloadImageLink?.url;
  return (
    hasContactLinks && (
      <ul className={`${styles.contactLinks} d-flex flex-column gap-2 p-0 m-0`}>
        {teamMemberData.phoneNumber?.value && (
          <li>
            <a
              href={`tel:${teamMemberData.phoneNumber.value}`}
              className="d-inline-flex gap-1 align-items-center"
            >
              <i className={`bi bi-telephone fs-4`} aria-hidden={true} />
              <span className="inline-link inline-link--small">
                {teamMemberData.phoneNumber.value}
              </span>
            </a>
          </li>
        )}
        {teamMemberData.email?.value && (
          <li>
            <a
              href={`mailto:${teamMemberData.email.value}`}
              className="d-inline-flex gap-1 align-items-center"
            >
              <i className={`bi bi-envelope fs-4`} aria-hidden={true} />
              <span className="inline-link inline-link--small">{teamMemberData.email.value}</span>
            </a>
          </li>
        )}
        {teamMemberData.linkedin?.url && (
          <li>
            <a
              href={teamMemberData.linkedin.url}
              target="_blank"
              rel="noopener noreferrer"
              className="d-inline-flex gap-1 align-items-center"
            >
              <i aria-hidden={true} className="bi bi-linkedin fs-4" />
              <span className="inline-link inline-link--small">LinkedIn</span>
              <span className="sr-only">Opens in a new window</span>
            </a>
          </li>
        )}
        {teamMemberData.twitter?.url && (
          <li>
            <a
              href={teamMemberData.twitter.url}
              target="_blank"
              rel="noopener noreferrer"
              className="d-inline-flex gap-1 align-items-center"
            >
              <i aria-hidden={true} className="bi bi-twitter fs-4" />
              <span className="inline-link inline-link--small">Twitter</span>
              <span className="sr-only">Opens in a new window</span>
            </a>
          </li>
        )}
        {teamMemberData.downloadImageLink?.url && (
          <li>
            <a
              href={teamMemberData.downloadImageLink.url}
              download
              className="d-inline-flex gap-1 align-items-center"
            >
              <i className={`bi bi-download fs-4`} aria-hidden={true} />
              <span className="inline-link inline-link--small">Download Image</span>
            </a>
          </li>
        )}
      </ul>
    )
  );
};
